export const baseUrl = process.env.NODE_ENV === 'development'
  ? 'http://localhost:8080/API'
  : '/API'

//cambiare cypress Json se process.env.NODE_ENV !== 'development'
export const itemsPerPage = 10
